import deliveredSrc from "../../assets/delivered.svg";
import informationLineSrc from "../../assets/information-line.svg";
import pinSrc from "../../assets/pin.svg";
import readSrc from "../../assets/read.svg";
import selectSrc from "../../assets/select.svg";
import tickSrc from "../../assets/tick.svg";

export interface SVGIconConfig {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export const TICK_ICON: SVGIconConfig = {
  src: tickSrc,
  alt: "sent",
  width: 14,
  height: 10,
};

export const DELIVERED_ICON: SVGIconConfig = {
  src: deliveredSrc,
  alt: "delivered",
  width: 14,
  height: 14,
};

export const READ_ICON: SVGIconConfig = {
  src: readSrc,
  alt: "read",
  width: 14,
  height: 14,
};

export const SELECT_ICON: SVGIconConfig = {
  src: selectSrc,
  alt: "selected",
  width: 35,
  height: 35,
};

export const PIN_ICON: SVGIconConfig = {
  src: pinSrc,
  alt: "Pinned",
  width: 16,
  height: 16,
};

export const INFORMATION_ICON: SVGIconConfig = {
  src: informationLineSrc,
  alt: "Information",
  width: 16,
  height: 16,
};
